import { Box, Typography } from '@mui/material';
import React from 'react';

export const CustomPillToggle = ({
  handleClick,
  checked,
  truthyValue,
  falsyValue
}: {
  handleClick: () => void;
  checked: boolean;
  truthyValue: string;
  falsyValue: string;
}) => {
  return (
    <Box
      onClick={handleClick}
      data-testid="#yes-no-toggle"
      sx={{
        position: 'relative',
        width: 70,
        height: 28,
        borderRadius: '9999px',
        backgroundColor: checked ? '#002A3A' : '#888B8D',
        cursor: 'pointer',
        userSelect: 'none'
      }}
    >
      {/* The text (“YES” or “NO”), absolutely positioned */}
      <Typography
        sx={{
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          fontFamily: '"Brandon Grotesque", sans-serif',
          fontWeight: 450,
          fontSize: '0.875rem',
          color: '#fff',
          pointerEvents: 'none',
          // left for YES, right for NO
          left: checked ? 8 : 'auto',
          right: checked ? 'auto' : 8
        }}
      >
        {checked ? truthyValue : falsyValue}
      </Typography>

      {/* The white circle that slides left or right */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          width: 18,
          height: 18,
          borderRadius: '50%',
          backgroundColor: '#fff',
          transition: 'left 0.2s ease, right 0.2s ease',
          // circle on the opposite side of the text
          left: checked ? 'auto' : 4,
          right: checked ? 4 : 'auto'
        }}
      />
    </Box>
  );
};
